var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.445 15.75C11.8474 15.75 11.2829 15.4961 10.9177 15.073L0.403829 2.80743C-0.249139 2.04581 -0.0941949 0.95067 0.75245 0.363277C1.5991 -0.224116 2.81648 -0.0847401 3.46945 0.67688L12.4561 11.1604L21.5368 0.67688C22.1953 -0.0847401 23.4126 -0.219144 24.2538 0.373227C25.0949 0.965599 25.2498 2.06074 24.5913 2.81738L13.9778 15.073C13.6126 15.4961 13.0482 15.745 12.4506 15.745L12.445 15.75Z",
    fill: "#0072AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonArrow);
export default __webpack_public_path__ + "static/media/button_arrow.232d2729a914168c6c1d60b1b1a92345.svg";
export { ForwardRef as ReactComponent };